import { createStore, type ReadOnlyStore } from "@observe-tech/mfe-shell-api";
import type { Site } from "@observe-tech/mfe-shell-api";

export interface SitesApi {
  list: ReadOnlyStore<Site[]>;
  selectedSiteId: ReadOnlyStore<string | null>;
  setSelectedSite(id: string): void;
  setFromIds(ids: number[]): void;
  refresh(): Promise<void>;
  selectedSiteIds: ReadOnlyStore<number[]>;
  setSelectedSiteIds(ids: number[]): void;
  selectedCageIds: ReadOnlyStore<string[]>;
  setSelectedCageIds(ids: string[]): void;
}

export function createSitesApi(): SitesApi {
  const list = createStore<Site[]>([]);
  const selected = createStore<string | null>(null);
  const selectedSiteIds = createStore<number[]>([]);
  const selectedCageIds = createStore<string[]>([]);

  function setFromIds(ids: number[]) {
    const unique = Array.from(new Set(ids));
    const sites: Site[] = unique.map((id) => ({
      id: String(id),
      name: `Site ${id}`,
      permissions: [],
    }));
    list.set(sites);
    if (!selected.store.get() && sites[0]) selected.set(sites[0].id);
  }

  return {
    list: list.store,
    selectedSiteId: selected.store,
    setSelectedSite: (id) => selected.set(id),
    setFromIds,
    refresh: async () => {
      // populated by permissions.refresh()
    },
    selectedSiteIds: selectedSiteIds.store,
    setSelectedSiteIds: (ids) => selectedSiteIds.set(ids),
    selectedCageIds: selectedCageIds.store,
    setSelectedCageIds: (ids) => selectedCageIds.set(ids),
  };
}
